export default __webpack_public_path__ + "static/media/icon-success.53946811.svg";